import styled, {css} from "styled-components"

const circledConnectorCss = css`
  ${({theme}) => css`
    font-size: 1.25em;

    .circledConnector_circled {
      color: ${theme.colors.utility.ink};
      background: ${theme.colors.utility.white};
      width: 2em;
      height: 2em;
      border: 1px solid #979797;
      text-align: center;
      border-radius: 50%;

      line-height: 2em;
      box-sizing: content-box;
      display: inline-block;
    }

    .circledConnector_circled svg {
      vertical-align: text-bottom !important;
    }

    & {
      padding-top: 5px;
    }

    & > .circledConnector_circledRow {
      border-left: 1px solid #c5c5c5;
    }

    & > .circledConnector_circledRow:last-child {
      border-left: 1px solid transparent;
    }

    .circledConnector_circledRow {
      margin-left: 1.25em;
      padding-bottom: 0em;
    }

    .circledConnector_circledRow .circledConnector_circled {
      float: left;
      margin: -5px 0 0 -1.1em;
      text-overflow: clip ellipsis;
    }

    .circledConnector_circledRow .circledConnector_circled + .circledConnector_circledText {
      margin-left: 3em;
      padding-top: 0px;
      min-height: 2em;
    }

    .circledConnector_circledRow .circledConnector_circled + .circledConnector_circledText .circledConnector_circledText p {
      margin: 0;
    }

    & > .circledConnector_circledRow .circledConnector_circled + .circledConnector_circledText {
      margin-left: 3em;
      display: flex;
      align-items: center;
      min-height: 60px;
      position: relative;
      bottom: 12px;
    }
  `}
`

export const Container = styled.div`
  ${circledConnectorCss}
`
